export enum PreviewStatus {
  start,
  loading,
  finish,
}
